import { HubSpotForm, JoinFormType, PackagePrices } from 'types/join';
import { getCookieUtmParams } from './cookie-user-data';

export const formatPlan = (plan: string) => {
  switch (plan.toLowerCase().replaceAll('_', '')) {
    case 'pricesheetmonthly':
      return 'Rapaport Plus';
    case 'pricesheetweekly':
      return 'Rapaport Basic';
    case 'rapaportplus':
      return 'Rapaport Plus';
    case 'rapaportbasic':
      return 'Rapaport Basic';
    case 'rapaportintelligencereport':
      return 'Rapaport Intelligence Report';
    case 'rapaporttradebuyerpro':
    case 'dealerlite':
      return 'Rapaport Trade Dealer Lite';
    case 'rapaporttradebuyer':
      return 'Rapaport Trade Buyer';
    case 'rapaporttradedealer':
      return 'Rapaport Trade Dealer';
    case 'rapaporttradebuyerproindia':
    case 'dealerliteindia':
      return 'Rapaport Trade Dealer Lite India';
    case 'rapaporttradebuyerindia':
      return 'Rapaport Trade Buyer India';
    case 'rapaporttradeprimarysupplier':
      return 'Rapaport Trade Primary Supplier';
    case 'rapaporttradegemdealer':
      return 'Rapaport Trade Gem Dealer';
    case 'rapaporttradegembuyer':
      return 'Rapaport Trade Gem Buyer';
    default:
      return plan;
  }
};

type CreateHubSpotFormProps = {
  form: JoinFormType;
  selectedPlan: PackagePrices;
};
export const CreateHubSpotForm = ({ selectedPlan, form }: CreateHubSpotFormProps): HubSpotForm => {
  const hutk = document.cookie
    .split('; ')
    .find(row => row.startsWith('hubspotutk='))
    ?.split('=')[1];

  // UTM parameters come from the URL when present, otherwise fall back to the
  // ones the pre-registration site captured in the `rapaport_user_data` cookie.
  const urlParams = new URLSearchParams(window.location.search);
  const cookieUtm = getCookieUtmParams();
  const utmCampaign = urlParams.get('utm_campaign') || cookieUtm.utmCampaign;
  const utmSource = urlParams.get('utm_source') || cookieUtm.utmSource;
  const utmMedium = urlParams.get('utm_medium') || cookieUtm.utmMedium;
  const utmContent = urlParams.get('utm_content') || cookieUtm.utmContent;
  const utmTerm = urlParams.get('utm_term') || cookieUtm.utmTerm;
  const landingPage = urlParams.get('landing_page') || window.location.href;
  const conversionPage = urlParams.get('conversion_page') || window.location.href;

  let leadsource = 'Registration - Rapaport Trade';
  if (selectedPlan?.subscriptionType === 'PriceList') {
    leadsource = 'Registration - Rapaport';
  }
  const context: any = {
    pageUri: window.location.href,
    pageName: document.title
  };

  if (hutk) {
    context.hutk = hutk;
  }
  const hbsptForm: HubSpotForm = {
    fields: [
      { name: 'firstname', value: form.firstName || '' },
      { name: 'lastname', value: form.lastName || '' },
      { name: 'email', value: form.email || '' },
      { name: 'country', value: form.companyCountry || '' },
      { name: 'marketing_primary_company_type', value: form.companyType || '' },
      { name: 'sync_to_hubspot', value: false },
      { name: 'leadsource', value: leadsource },
      { name: 'initial_plan_pick', value: formatPlan(form.initialPlan || '') },
      { name: 'requested_plan_pick', value: selectedPlan.packageName },
      { name: 'utm_campaign_temp', value: utmCampaign },
      { name: 'utm_source_temp', value: utmSource },
      { name: 'utm_medium_temp', value: utmMedium },
      { name: 'utm_content__temp_', value: utmContent },
      { name: 'utm_term__temp_', value: utmTerm },
      { name: 'landing_page_temp', value: landingPage },
      { name: 'conversion_page_temp', value: conversionPage }
    ],
    context
  };

  return hbsptForm;
};
